import { useQuery } from "react-query";
import { axios } from "../../lib/axios";
import { onError } from "./onError";



export function useSurveyQueryData({ orgID, onSuccess, ...props }) {
    const fetch = () => {
        return axios.get(orgID == 'All' ? "/questionnaire?purpose=survey" : `questionnaire?purpose=survey&orgId=${orgID}`);
    }
    const query = useQuery(
        ["questionnaires-sorting-list",orgID],
        fetch,
        {
            select: (data) => data.data,
            onError,
            onSuccess,
            ...props
        }
    );
    return { ...query };
}
